import { render, staticRenderFns } from "./EducationFeedbacksTab.vue?vue&type=template&id=2a052628&scoped=true"
import script from "./EducationFeedbacksTab.vue?vue&type=script&lang=js"
export * from "./EducationFeedbacksTab.vue?vue&type=script&lang=js"
import style0 from "./EducationFeedbacksTab.vue?vue&type=style&index=0&id=2a052628&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a052628",
  null
  
)

export default component.exports